import { TFunction } from "i18next";
import * as yup from "yup";

import { OtherParentBasicInfoValidation } from "./OtherParentValidationSchema";

interface Props {
  t: TFunction;
}

export const CheckOtherParentValidationSchema = ({ t }: Props) => {
  return yup.object().shape({
    ...OtherParentBasicInfoValidation(t),
  });
};
